module.exports = __webpack_public_path__ + "img/second-section-1.2a95f947.jpg";